import React, { useRef, useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProfilePopup = ({ handleLogout, expertDetails, onClose }) => {
  const modalRef = useRef(null);
  const [profileImageFile, setProfileImageFile] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleProfileImageChange = (event) => {
    const file = event.target.files[0];
    setProfileImageFile(file);

    // Display the selected image
    const imageUrl = URL.createObjectURL(file);
    setProfileImageUrl(imageUrl); // Assuming you have a state variable for the image URL
  };

  const handleLogoutClick = () => {
    handleLogout();
  };

  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem("EXPERT_AUTH_TOKEN");
      const formData = new FormData();
      formData.append("profileImage", profileImageFile);
      console.log(formData);
      const response = await fetch(
        `${baseUrl}/api/expert/profile/${expertDetails._id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `${token}`,
          },
          body: formData,
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.log(data.data);
      localStorage.setItem("EXPERT_INFO", JSON.stringify(data.data));
      console.log("Image updated successfully", data);

      // Display success message
      toast.success("Image submitted successfully");

      onClose();
    } catch (error) {
      console.error("Error updating profile image :", error);

      // Display error message
      toast.error("Error updating profile image ");
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div
        ref={modalRef}
        className="bg-white mx-5 shadow-lg rounded-lg lg:w-1/3 p-6"
      >
        <div className="profile mb-10 flex flex-col items-center justify-center">
          <div className="relative">
            {/* Profile image */}
            <img
              src={profileImageUrl || expertDetails.profileImageUrl}
              alt="User Profile"
              className="rounded-full w-32 h-32"
            />
            {/* Button to update profile picture */}
            <label
              htmlFor="profileImageInput"
              className="absolute bottom-0 right-0 bg-blue-500 text-white rounded-full cursor-pointer p-2"
            >
              <input
                id="profileImageInput"
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleProfileImageChange}
              />
              <FiEdit className="h-6 w-6" />
            </label>
          </div>
          <h1 className="text-black text-3xl font-semibold pt-2">
            {expertDetails.name}
          </h1>
          <p className="text-black">{expertDetails.email}</p>
          <button
            className="mt-5 bg-blue-500 text-white px-4 py-2 rounded-md"
            onClick={handleLogoutClick}
          >
            Logout
          </button>
        </div>
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md mr-2"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="bg-blue-500 text-white px-4 py-2 rounded-md"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfilePopup;
